import React from 'react'

function Foodicon() {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
            <g fill="#000000">
                <path d="M42.369,6.925c-0.853-0.853-2.219-0.853-3.072,0L16.319,30.875l-7.676-7.676c-0.853-0.853-2.219-0.853-3.072,0 c-0.853,0.853-0.853,2.219,0,3.072L13.594,37.95c0.853,0.853,2.219,0.853,3.072,0L42.369,10.997 C43.222,9.144,43.222,7.778,42.369,6.925z" />
            </g>
        </svg>
    );

}

export default Foodicon